function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import './style.less';
import ContextmenuItem from './contextmenu-item';

var Contextmenu = /*#__PURE__*/function () {
  function Contextmenu() {
    _classCallCheck(this, Contextmenu);

    this.menu = document.createElement('ul');
    this.menu.classList.add('px-context-menu');
    this.items = {};
    this.context = null;
  }

  _createClass(Contextmenu, [{
    key: "add",
    value: function add(label, icon) {
      var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var item = new ContextmenuItem(label, icon, this);
      if (typeof name === 'string') this.items[name] = item;
      this.menu.appendChild(item.item);
      return item;
    }
  }, {
    key: "disableAll",
    value: function disableAll() {
      for (name in this.items) {
        this.disable(name);
      }
    }
  }, {
    key: "enableAll",
    value: function enableAll() {
      for (name in this.items) {
        this.enable(name);
      }
    }
  }, {
    key: "disable",
    value: function disable() {
      var _this = this;

      for (var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++) {
        names[_key] = arguments[_key];
      }

      names.forEach(function (name) {
        return _this.items[name].disable();
      });
    }
  }, {
    key: "enable",
    value: function enable() {
      var _this2 = this;

      for (var _len2 = arguments.length, names = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        names[_key2] = arguments[_key2];
      }

      names.forEach(function (name) {
        return _this2.items[name].enable();
      });
    }
  }, {
    key: "setItemStatus",
    value: function setItemStatus(name, status) {
      if (status) this.items[name].enable();else this.items[name].disable();
    }
  }, {
    key: "show",
    value: function show(event, context) {
      var _this3 = this;

      this.overlay = document.createElement('div');
      this.overlay.classList.add('px-context-menu-overlay');
      this.overlay.addEventListener('click', function (event) {
        _this3.hide();
      });
      this.overlay.addEventListener('contextmenu', function (event) {
        _this3.hide();

        event.preventDefault();
      });
      document.body.appendChild(this.overlay);
      document.body.appendChild(this.menu);
      event.preventDefault();
      this.context = context;
      this.menu.classList.add('active');
      var coords = this.constructor.getCoords(event);
      var y = coords.clickY;
      var x = coords.clickX;
      if (coords.clientY + this.menu.offsetHeight + 10 > window.innerHeight) y -= this.menu.offsetHeight + coords.clientY - window.innerHeight + 10;
      if (coords.clientX + this.menu.offsetWidth + 10 > window.innerWidth) x -= this.menu.offsetWidth + coords.clientX - window.innerWidth + 10;
      this.menu.style.top = y + 'px';
      this.menu.style.left = x + 'px';
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this$menu;

      document.body.removeChild(this.menu);
      document.body.removeChild(this.overlay);
      (_this$menu = this.menu) === null || _this$menu === void 0 ? void 0 : _this$menu.classList.remove('active');
    }
  }], [{
    key: "getCoords",
    value: function getCoords(event) {
      var clickX = 0;
      var clickY = 0;

      if ((event.clientX || event.clientY) && document.body && document.body.scrollLeft != null) {
        clickX = event.clientX + document.body.scrollLeft;
        clickY = event.clientY + document.body.scrollTop;
      }

      if ((event.clientX || event.clientY) && document.compatMode === 'CSS1Compat' && document.documentElement && document.documentElement.scrollLeft != null) {
        clickX = event.clientX + document.documentElement.scrollLeft;
        clickY = event.clientY + document.documentElement.scrollTop;
      }

      if (event.pageX || event.pageY) {
        clickX = event.pageX - 5;
        clickY = event.pageY - 5;
      }

      return {
        clickX: clickX,
        clickY: clickY,
        clientX: event.clientX,
        clientY: event.clientY,
        screenX: event.screenX,
        screenY: event.screenY
      };
    }
  }]);

  return Contextmenu;
}();

export { Contextmenu as default };